export const PAGE_SIZE = 3000;
export const AUTHOR_TYPES = {
    USER: 'user',
    MANUAL_USER: 'manualUser',
    AGENCY: 'agency',
    MANUAL_AGENCY: 'manualAgency',
    SERVICE_USER: 'serviceUser',
    CONTRIBUTOR: 'contributor',
} as const;
